import { getOfficeDivision } from "../../../../../actions/Utilities/OfficeDivision";
import { useQuery } from "react-query";

export default function useOfficeDivision() {
  const {data, isFetching} = useQuery("GetOfficeDivision", getOfficeDivision, {
    refetchOnWindowFocus: false,
  });

  return {data, isFetching};
}
